import { render, staticRenderFns } from "./StratShadow.vue?vue&type=template&id=07e7e7c4&"
import script from "./StratShadow.vue?vue&type=script&lang=js&"
export * from "./StratShadow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports